/**
* @name: collection-menu-list
* @author: weiyong
* @date: 2024-10-06 20:55
* @description：collection-menu-list
* @update: 2024-10-06 20:55
*/
<template>
  <div class="collection-menu-list">
    <div @click="selActiveOneMenu(item)"
         :key="item.id"
         :class="activeMenuId===item.id?'active-menu':'not-active-menu'"
         type="link"
         class="w100b menu-btn" v-for="item in menuList">
      <span class="icon-span">
        <i :class="item.source"></i>
      </span>
      {{ item.name || item.label }}
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "collection-menu-list",
});
</script>

<script lang="ts" setup>

import {useCollectMenus} from "@/layouts/layoutFrame/hooks/useCollectMenus";
import {useMenuStore} from "@/layouts/layoutFrame/military/viewStore/menuStore";
import {useRouter} from "vue-router";
import {useI18n} from "@/hooks/web/useI18n";
import {useMenuHooks} from "@/layouts/layoutFrame/hooks/useMenuHooks";

const menuStore = useMenuStore();
const {
  activeMenuId,
  menuProps
}:any = storeToRefs(menuStore)



const router = useRouter();
const { t } = useI18n();

const closePanel = function () {
  unref(menuProps).showMenu = false;
}

const {
  menuClick
}=useMenuHooks(router,t);
const selActiveOneMenu=function (item){
  activeMenuId.value=item.id;
  menuClick({key:item.path,menuId:item.id},unref(menuList));
  closePanel();
}


const menuList:any=ref([]);
const flushList=function (list){
  if(list&&Array.isArray(list)){
    menuList.value=list;
  }
}
const {collectMenu,getCollectMenus,spinning}=useCollectMenus(flushList);

onMounted(()=>{
  getCollectMenus(flushList);
})
</script>

<style type="text/css" lang="less">
.collection-menu-list{
  .menu-btn {
    text-align: left;
    border-left:2px solid #eee;
    line-height:var(--menu-main-bar-height,38px);
    padding-left: 12px;
    cursor:pointer;
    position: relative;
    color:#666;
    &:hover{
      background-color: #F0F0F0;
    }
    .icon-men{
      display: inline-block;
      padding-right: 6px;
    }

    &:hover{
      color:var(--primary-color,#0a6eff);
      border-left:2px solid var(--primary-color,#0a6eff);
      z-index: 100;
    }
    &.active-menu{
      background-color: #F0F0F0;
      color:var(--primary-color,#0a6eff);
      border-left:2px solid var(--primary-color,#0a6eff);
      &:before{
        content: ' ';
        width: 4px;
        background-color: var(--primary-color,#F15001);
        position: absolute;
        height: 100%;
        position: absolute;
        border-radius: 0 2px 2px 0;
        left: -2px;
        top: 0;
      }
    }
  }
}

</style>
